import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  deletedRepository: {
    id: 'frontbucket.dashboard.overview.pullRequestsTable.deletedRepository',
    description: 'String informing that the repository does not exist anymore.',
    defaultMessage: 'Deleted repository',
  },
});
